exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel__item[data-v-49a642fc]{padding:0 .625rem;text-align:center}@media screen and (min-width:48em){.carousel__item[data-v-49a642fc]{padding:0 .75rem;padding:0 .5rem}}", ""]);

// exports
